<div id="ht">
    <div id="main-cnt">

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">
                        <!-- edit da qui... -->
                        <form (ngSubmit)="saveContract()" [formGroup]="contractForm">
                            <div *ngIf="permission !== PermissionType.CLIENT">
                                <!-- <ion-input *ngIf="client" disabled="true" placeholder="Intestatario" class="text-input"
                                            type="text" value="{{client.lastname+' '+ client.name}}"></ion-input>-->
                                <ion-label position="floating">Selezione Cliente</ion-label>
                                <ion-select [compareWith]="compareWith"
                                            class="inputItem item-leave-height no-arrow"
                                            class="text-input" interface="action-sheet" formControlName="client"
                                            placeholder="Select Client">
                                    <ion-select-option *ngFor="let client of clients"
                                                       [value]="client"> {{ client?.lastname |titlecase }} {{ client?.name |titlecase }}
                                    </ion-select-option>
                                </ion-select>
                            </div>
                            <div *ngIf="sessionService.user.permessions === sessionService.permissionType.ADMINISTRATOR">
                                <ion-label position="floating">Seleziona Commerciale</ion-label>
                                <ion-select [compareWith]="compareWith"

                                            interface="action-sheet" class="inputItem item-leave-height no-arrow"
                                            formControlName="addedBy" placeholder="Select Commerciale">
                                    <ion-select-option *ngFor="let c of commerciali"
                                                       [value]="c">{{ c?.lastname |titlecase }} {{ c?.name|titlecase }}
                                    </ion-select-option>
                                </ion-select>
                            </div>
                            <ion-label position="floating">Prodotto</ion-label>
                            <ion-select interface="action-sheet" class="inputItem item-leave-height no-arrow"
                                        formControlName="product"
                            >
                                <ion-select-option value="Start">Start</ion-select-option>
                                <ion-select-option value="Shield">Shield</ion-select-option>
                                <ion-select-option value="Dst">Dst</ion-select-option>
                            </ion-select>
                            <ion-label position="floating">Capitale</ion-label>
                            <ion-input placeholder="Capitale" class="text-input" formControlName="amount"
                                       type="text"></ion-input>
                            <ion-label position="floating">Durata contratto</ion-label>
                            <ion-select interface="action-sheet" class="inputItem item-leave-height no-arrow"
                                        formControlName="contractYears"
                            >
                                <ion-select-option value="1">1</ion-select-option>
                                <ion-select-option value="2">2</ion-select-option>
                                <ion-select-option value="3">3</ion-select-option>
                                <ion-select-option value="4">4</ion-select-option>
                                <ion-select-option value="5">5</ion-select-option>
                                <ion-select-option value="6">6</ion-select-option>
                                <ion-select-option value="7">7</ion-select-option>
                                <ion-select-option value="8">8</ion-select-option>
                                <ion-select-option value="9">9</ion-select-option>
                                <ion-select-option value="10">10</ion-select-option>
                                <ion-select-option value="11">11</ion-select-option>
                                <ion-select-option value="12">12</ion-select-option>
                                <ion-select-option value="13">13</ion-select-option>
                                <ion-select-option value="14">14</ion-select-option>
                                <ion-select-option value="15">15</ion-select-option>
                                <ion-select-option value="16">16</ion-select-option>
                                <ion-select-option value="17">17</ion-select-option>
                                <ion-select-option value="18">18</ion-select-option>
                                <ion-select-option value="19">19</ion-select-option>
                                <ion-select-option value="20">20</ion-select-option>
                            </ion-select>
                            <ion-label class="addInput-Label" position="floating">Data inizio</ion-label>
                            <ion-input placeholder="Data inizio" class="text-input" formControlName="startDate"
                                       type="date"></ion-input>
                            <!--<ion-label position="floating">Data inserimento</ion-label>
                            <ion-input placeholder="Date" class="text-input" formControlName="date"
                                       type="date"></ion-input>

                            <ion-label class="addInput-Label" position="floating">Data fine </ion-label>

                            <ion-input placeholder="Data fine" class="text-input" formControlName="endDate"
                                       type="date"></ion-input> -->
                            <ion-label position="floating">Percentuale</ion-label>
                            <ion-input placeholder="Percentuale" class="text-input" formControlName="percent"
                                       type="number"></ion-input>
                            <div *ngIf="sessionService.user.permessions === sessionService.permessionTypes.ADMINISTRATOR">


                                <ion-label position="floating">Stato</ion-label>
                                <ion-select

                                        class="text-input" interface="action-sheet" placeholder="Enter contract status"
                                        formControlName="status"
                                >
                                    <ion-select-option *ngFor="let status of statusList" [value]="status"
                                                       disabled="true ">{{ status }}
                                    </ion-select-option>
                                </ion-select>
                            </div>
                            <ion-textarea placeholder="Notes" class="text-input" formControlName="notes"
                                          type="text"></ion-textarea>
                            <app-file-picker #filePicker buttonText="Scegli File"
                                             baseDirectory="contracts/{{sessionService.user.id}}/"></app-file-picker>

                            <br>
                            <div *ngIf="sessionService.user.permessions === sessionService.permessionTypes.ADMINISTRATOR">


                                <button expand="block" type="submit"
                                        class="button glass-blurred-background drop-shadow padding">Save
                                </button>
                            </div>

                            <div *ngIf="sessionService.user.permessions === sessionService.permessionTypes.CLIENT">


                                <button expand="block" type="submit"
                                        class="button glass-blurred-background drop-shadow padding">Save
                                </button>
                            </div>
                            <div *ngIf="sessionService.user?.permessions === sessionService.permessionTypes.COMMERCIAL && currentContract?.status !== contractStatus?.ACTIVE">
                                <button expand="block" type="submit"
                                        class="button glass-blurred-background drop-shadow padding">Save
                                </button>
                                <!--<button (click)="changeStatus(contractStatus.TOVERIFY)"
                                        *ngIf="currentContract?.status === contractStatus.DRAFT"> Invia in verifica
                                </button>
                                <button (click)="changeStatus(contractStatus.PAYED)"
                                        *ngIf="currentContract?.status === contractStatus.TOBEPAYED"> Pagamento
                                    effettuato
                                </button>-->
                                <!-- <button expand="block" type="submit"
                                         *ngIf="currentContract?.status === contractStatus.DRAFT"
                                         class="button glass-blurred-background drop-shadow padding">Salva
                                 </button>-->
                            </div>

                        </form>

                        <!-- ...a qui -->
                    </div>
                </div>
            </div>
        </ion-content>

    </div>
</div>


<!--
<ion-header>
    <ion-toolbar>
        <div class="modal-top"></div>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding model-content">
    <form (ngSubmit)="saveContract()" [formGroup]="contractForm">
        <ion-list class="inputLabel">
            <ion-item class="inputItem" detail="false" *ngIf="client">
                <ion-label class="addInput-Label">Intestatario</ion-label>
                <ion-input disabled="true" type="text" class="addInput" value="{{client.lastname+' '+ client.name}}"></ion-input>
            </ion-item>
            <ion-item *ngIf="!currentContract&&!client" class="inputItem item-leave-height no-arrow" detail="false">
                <ion-label class="addInput-Label" position="floating">Client</ion-label>
                <ion-select interface="action-sheet" formControlName="client" placeholder="Select Client">
                    <ion-select-option *ngFor="let client of clients" [value]="client.id">{{client.name}} {{client.lastname}}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item *ngIf="sessionService.user.permessions === sessionService.permissionType.ADMINISTRATOR" class="inputItem item-leave-height no-arrow" detail="false">
                <ion-label class="addInput-Label" position="floating">Aggiunto Da</ion-label>
                <ion-select interface="action-sheet" formControlName="addedBy" placeholder="Select Client">
                    <ion-select-option *ngFor="let c of commerciali" [value]="c.id">{{c.name}} {{c.lastname}}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label" position="floating">Prodotto scelto</ion-label>
                <ion-input class="addInput" formControlName="product" type="text"></ion-input>
            </ion-item>

            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label" position="floating">Capitale</ion-label>
                <ion-input class="addInput" formControlName="amount" type="text"></ion-input>
            </ion-item>

            <ion-item class="inputItem no-arrow" detail="false">
                <ion-label class="addInput-Label" position="floating">Date</ion-label>
                <ion-input class="addInput" formControlName="date" type="date"></ion-input>
            </ion-item>
            <ion-item class="inputItem no-arrow" detail="false">
                <ion-label class="addInput-Label" position="floating">Data inizio</ion-label>
                <ion-input class="addInput" formControlName="startDate" type="date"></ion-input>
            </ion-item>
            <ion-item class="inputItem no-arrow" detail="false">
                <ion-label class="addInput-Label" position="floating">Data Fine</ion-label>
                <ion-input class="addInput" formControlName="endDate" type="date"></ion-input>
            </ion-item>

            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label" position="floating">percentuale</ion-label>
                <ion-input class="addInput" formControlName="percent" type="number"></ion-input>
            </ion-item>

            <ion-item class="inputItem item-leave-height no-arrow" detail="false">
                <ion-label class="addInput-Label" position="floating">Status</ion-label>
                <ion-label class="addInput-Label" color="success" *ngIf="currentContract?.status === contractStatus.ACTIVE">ATTIVO
                </ion-label>
                <ion-select interface="action-sheet" placeholder="Enter contract status" formControlName="status" *ngIf="currentContract?.status !== contractStatus.ACTIVE">
                    <ion-select-option *ngFor="let status of statusList" [value]="status" disabled="true ">{{status}}</ion-select-option>
                </ion-select>
            </ion-item>

            <ion-item class="inputItem" detail="false">
                <ion-label class="addInput-Label" position="floating">Notes</ion-label>
                <ion-textarea class="addInput" formControlName="notes"></ion-textarea>
            </ion-item>

            <app-file-picker #filePicker buttonText="Scegli File" baseDirectory="contracts/{{sessionService.user.id}}/"></app-file-picker>


        </ion-list>

        <ion-button expand="block" type="submit" class="loginButton">{{ saveContractButtonText }}</ion-button>
    </form>
</ion-content> -->
